import { Injectable } from '@angular/core';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { CaptureVideoOptions } from '@awesome-cordova-plugins/media-capture/ngx';
import { CameraResultType, CameraSource, ImageOptions } from '@capacitor/camera';
import { AppSettingsService, SagaSettingsService } from '@services/settings';
import { MediaSource } from '../../schema/enums/media-source';

const DEFAULT_IMAGE_QUALITY: number = 80;

@Injectable()
export class CaptureOptionsFactoryService {
  private imageQuality: number = DEFAULT_IMAGE_QUALITY;

  private readonly defaultImageOptions: ImageOptions = {
    quality: 100,
    resultType: CameraResultType.Uri,
    correctOrientation: true,
    saveToGallery: false,
    height: 800,
    width: 800
  };

  constructor(private sagaSettingsService: SagaSettingsService, private appSettings: AppSettingsService, private device: Device) {
    this.appSettings.getCameraQuality().subscribe(quality => (this.imageQuality = quality || DEFAULT_IMAGE_QUALITY));
  }

  createImageOptions(mediaSource: MediaSource.Camera | MediaSource.Gallery): ImageOptions {
    const cameraSource: CameraSource = mediaSource === MediaSource.Gallery ? CameraSource.Photos : CameraSource.Camera;
    const cameraOptions: ImageOptions = Object.assign({}, this.defaultImageOptions, {
      quality: this.imageQuality,
      source: cameraSource
    });

    if (this.device.platform === 'Android') {
      cameraOptions.width = 1024;
      cameraOptions.quality = 50;
    }

    const customSettings = this.sagaSettingsService.getValue('PictureSettings');
    if (customSettings != null) {
      Object.assign(cameraOptions, JSON.parse(customSettings));
    }

    return cameraOptions;
  }

  createVideoOptions(): CaptureVideoOptions {
    const videoOptions: CaptureVideoOptions = {
      limit: 1, // the nr of videos to record
      duration: 60,
      quality: 1
    };

    const customSettings = this.sagaSettingsService.getValue('VideoSettings');
    if (customSettings != null) {
      Object.assign(videoOptions, JSON.parse(customSettings));
    }

    return videoOptions;
  }
}
